'use client'

import React, { useEffect, useState } from 'react'
import { Image } from '@chakra-ui/react'
import { ProductImageVariantVersions } from '@leid/api-products'

import { handleImageError } from 'utils/imageFallback'

type ImageVersionType = 'thumbnail' | 'preview' | 'medium'

type Props = {
  productDefaultImage: string
  imageVersions: ProductImageVariantVersions[]
  desiredVersion?: ImageVersionType
  altText: string
  htmlWidth?: string
  htmlHeight?: string
}

const ProductImageView = ({
  productDefaultImage,
  imageVersions,
  desiredVersion = 'medium',
  altText = '',
  htmlWidth,
  htmlHeight,
}: Props) => {
  // Just get's 0 index for now, extend with props if needed
  const getImageUrl = () => {
    if (!imageVersions[0] || !imageVersions[0].cdn) return productDefaultImage
    const cdn = imageVersions[0].cdn
    if (typeof cdn?.[desiredVersion] === 'string' && cdn[desiredVersion]) {
      return cdn[desiredVersion]
    }
    return productDefaultImage
  }

  const [currentImageUrl, setCurrentImageUrl] = useState<string | undefined>(productDefaultImage)
  const [imageErrorLevel, setImageErrorLevel] = useState(0)

  useEffect(() => {
    if (currentImageUrl === undefined || imageVersions || desiredVersion) {
      setCurrentImageUrl(getImageUrl())
    }
  }, [imageVersions, desiredVersion])

  const handleImageErrorFallback = () => {
    handleImageError(
      productDefaultImage,
      currentImageUrl,
      imageErrorLevel,
      setCurrentImageUrl,
      setImageErrorLevel,
      // Default fallback? Currently just using the product image as default
    )
  }

  return (
    <Image
      loading="lazy"
      src={currentImageUrl}
      onError={() => handleImageErrorFallback()}
      alt={altText}
      htmlHeight={htmlHeight}
      height={htmlHeight}
      objectFit="cover"
      // aspectRatio="16 / 9"
    />
  )
}

export default ProductImageView
